let bJourneyLoaded = false; /**WEBMESS-540: boolean variable to determine if the Journey plugin is already initialized or not, when the Genesys.init command is getting called without page refresh*/

function initJourney(config, GenesysJS) {
  const journey = config.deploymentConfig.journeyEvents||{};

  if (journey.enabled === true && !bJourneyLoaded) {
    bJourneyLoaded = true;
    GenesysJS.log('JourneyEvents enabled. Loading Journey plugin.');

    // TODO: remove plugin-specific init data once plugin has been updated
    Genesys('loadPlugin', 'Journey', Object.assign({}, config, {
      apiEndpoint: config.deploymentConfig.apiEndpoint,
      deploymentId: config.snippetConfig.deploymentId,
    }));
  }
}

export default initJourney;
